export const GET_TEST_SETS_FILES_REQUEST = 'GET_TEST_SETS_FILES_REQUEST';
export const GET_TEST_SETS_FILES_SUCCESS = 'GET_TEST_SETS_FILES_SUCCESS';
export const GET_TEST_SETS_FILES_ERROR = 'GET_TEST_SETS_FILES_ERROR';
export const GET_TEST_SETS_FILE_REQUEST = 'GET_TEST_SETS_FILE_REQUEST';
export const GET_TEST_SETS_FILE_SUCCESS = 'GET_TEST_SETS_FILE_SUCCESS';
export const GET_TEST_SETS_FILE_ERROR = 'GET_TEST_SETS_FILE_ERROR';
export const ADD_TEST_SETS_FILE_REQUEST = 'ADD_TEST_SETS_FILE_REQUEST';
export const ADD_TEST_SETS_FILE_SUCCESS = 'ADD_TEST_SETS_FILE_SUCCESS';
export const ADD_TEST_SETS_FILE_ERROR = 'ADD_TEST_SETS_FILE_ERROR';
export const UPLOAD_TEST_SETS_FILES_REQUEST = 'UPLOAD_TEST_SETS_FILES_REQUEST';
export const UPLOAD_TEST_SETS_FILE_REQUEST = 'UPLOAD_TEST_SETS_FILE_REQUEST';
export const UPLOAD_TEST_SETS_FILE_SUCCESS = 'UPLOAD_TEST_SETS_FILE_SUCCESS';
export const UPLOAD_TEST_SETS_FILE_ERROR = 'UPLOAD_TEST_SETS_FILE_ERROR';
export const UPLOAD_TEST_SETS_FILES_SUCCESS = 'UPLOAD_TEST_SETS_FILES_SUCCESS';
export const UPLOAD_TEST_SETS_FILES_ERROR = 'UPLOAD_TEST_SETS_FILES_ERROR';
export const UPDATE_TEST_SETS_FILE_REQUEST = 'UPDATE_TEST_SETS_FILE_REQUEST';
export const UPDATE_TEST_SETS_FILE_SUCCESS = 'UPDATE_TEST_SETS_FILE_SUCCESS';
export const UPDATE_TEST_SETS_FILE_ERROR = 'UPDATE_TEST_SETS_FILE_ERROR';
export const ADD_TEST_SETS_NEW_FILE = 'ADD_TEST_SETS_NEW_FILE';
export const DELETE_TEST_SETS_FILE_REQUEST = 'DELETE_TEST_SETS_FILE_REQUEST';
export const DELETE_TEST_SETS_FILE_SUCCESS = 'DELETE_TEST_SETS_FILE_SUCCESS';
export const DELETE_TEST_SETS_FILE_ERROR = 'DELETE_TEST_SETS_FILE_ERROR';
export const EXPORT_TEST_SETS_FILE_REQUEST = 'EXPORT_TEST_SETS_FILE_REQUEST';
export const EXPORT_TEST_SETS_FILE_SUCCESS = 'EXPORT_TEST_SETS_FILE_SUCCESS';
export const EXPORT_TEST_SETS_FILE_ERROR = 'EXPORT_TEST_SETS_FILE_ERROR';
export const SET_TEST_SETS_DEFAULT_PERCENTAGE_TO_FILE =
  'SET_TEST_SETS_DEFAULT_PERCENTAGE_TO_FILE';
export const RESET_TEST_SETS_UPLOAD_FILES = 'RESET_TEST_SETS_UPLOAD_FILES';
export const UPDATE_TEST_SETS_SEARCH_TERM = 'UPDATE_TEST_SETS_SEARCH_TERM';
export const CLOSE_TEST_SETS_FILE = 'CLOSE_TEST_SETS_FILE';
export const UPDATE_TEST_SETS_BLOB_REQUEST = 'UPDATE_TEST_SETS_BLOB_REQUEST';
export const UPDATE_TEST_SETS_BLOB_SUCCESS = 'UPDATE_TEST_SETS_BLOB_SUCCESS';
export const UPDATE_TEST_SETS_BLOB_ERROR = 'UPDATE_TEST_SETS_BLOB_ERROR';
export const UPDATE_TEST_SETS_EDITOR_SEARCH_TERM =
  'UPDATE_TEST_SETS_EDITOR_SEARCH_TERM';
export const SET_TEST_SETS_THEME = 'SET_TEST_SETS_THEME';
export const OPEN_TEST_SETS_FILE = 'OPEN_TEST_SETS_FILE';

export const GET_TEST_SETS_LIST_REQUEST = 'GET_TEST_SETS_REQUEST';
export const GET_TEST_SETS_LIST_SUCCESS = 'GET_TEST_SETS_SUCCESS';
export const GET_TEST_SETS_LIST_ERROR = 'GET_TEST_SETS_ERROR';
export const GET_TEST_SET_REQUEST = 'GET_TEST_SET_REQUEST';
export const GET_TEST_SET_SUCCESS = 'GET_TEST_SET_SUCCESS';
export const GET_TEST_SET_ERROR = 'GET_TEST_SET_ERROR';
export const UPDATE_TEST_SETS_PAGINATION_PARAMS =
  'UPDATE_TEST_SETS_PAGINATION_PARAMS';
export const SELECT_TEST_SET = 'SELECT_TEST_SET';
export const DESELECT_TEST_SET = 'DESELECT_TEST_SET';

export const DELETE_TEST_SETS_FILES_REQUEST = 'DELETE_TEST_SETS_FILES_REQUEST';
export const DELETE_TEST_SETS_FILES_SUCCESS = 'DELETE_TEST_SETS_FILES_SUCCESS';
export const DELETE_TEST_SETS_FILES_ERROR = 'DELETE_TEST_SETS_FILES_ERROR';
export const EXPORT_TEST_SETS_FILES_REQUEST = 'EXPORT_TEST_SETS_FILES_REQUEST';
export const EXPORT_TEST_SETS_FILES_SUCCESS = 'EXPORT_TEST_SETS_FILES_SUCCESS';
export const EXPORT_TEST_SETS_FILES_ERROR = 'EXPORT_TEST_SETS_FILES_ERROR';
export const OPEN_TEST_SETS_FILES_REQUEST = 'OPEN_TEST_SETS_FILES_REQUEST';
export const OPEN_TEST_SETS_FILES_SUCCESS = 'OPEN_TEST_SETS_FILES_SUCCESS';
export const OPEN_TEST_SETS_FILES_ERROR = 'OPEN_TEST_SETS_FILES_ERROR';
